export class ImageSizeError extends Error {
  constructor(message = 'Invalid image size') {
    super(message)
    this.name = 'ImageSizeError'
  }
}

export class MissingPaymentIntentError extends Error {
  constructor(message = 'Missing payment intent') {
    super(message)
    this.name = 'MissingPaymentIntentError'
  }
}
